import { useEffect, useState } from "react";
import { removeCityFromAddr } from "../logics/garbageCollectionPoints";
import { useStore } from "effector-react";
import {
  $clickedPoint,
  ICollectionPoint,
} from "../logics/garbageCollectionPoints";
import { IRoute } from "../logics/routes";
import {
  CarHereAndMovingDown,
  CarHereAndMovingUp,
  CarNotHere,
  PointListItem,
} from "../atoms/PointListItem";
import { PointType } from "../atoms/PointType";
import { RouteData } from "../atoms/RouteData";
import "../styles/RoutePanel.css";

export interface IRoutePanel {
  routes: IRoute[];
  points: ICollectionPoint[];
  isHidden: boolean;
}

// const divStyle = {
//   position: "absolute",
//   background: backRoutePanel,
//   borderRadius: "12px 12px 12px 12px",
//   width: "375px",
//   top: "149px",
//   left: "24px",
//   zIndex: 10,
//   maxHeight: "80%",
// } as React.CSSProperties;

export const RoutePanel = ({ routes, points, isHidden }: IRoutePanel) => {
  const [panelHidden, setPanelHidden] = useState<boolean>(false);
  const point = useStore($clickedPoint);
  useEffect(() => {
    setPanelHidden(false);
  }, [point]);
  useEffect(() => {
    let elems = document.getElementsByClassName("clicked-elem");
    if (elems.length > 0) elems[0].scrollIntoView();
  });
  if (
    point == null ||
    points.length === 0 ||
    point.pointIdx > points.length - 1
  )
    return <></>;
  let route = routes[point.routeIdx];
  const prevPointId = route.garbageCarPreviousPointId;
  const currPointId = point.pointId;
  const nextPointId = route.garbageCarNextPointId;
  const routePoints = route.garbageCollectionPoints;
  let p = points[point.pointIdx];
  const maxIdx = route.garbageCollectionPoints.length - 1;
  const idxInRoute = point.idxInRoute;
  const pointInRoute = routePoints[point.idxInRoute];

  const isCarHere2 = (i: number) => {
    if (maxIdx === 0 || routePoints[i].pointId !== prevPointId)
      return CarNotHere;
    if (i === 0) return CarHereAndMovingDown;
    else if (i === maxIdx) return CarHereAndMovingUp;
    if (routePoints[i + 1].pointId === nextPointId) return CarHereAndMovingDown;
    return CarHereAndMovingUp;
  };

  return (
    <div className="route-panel" hidden={panelHidden}>
      <p className="route-panel__adress">{removeCityFromAddr(p.address)}</p>
      <button
        className="route-panel__close"
        type="button"
        onClick={() => setPanelHidden(true)}
      >
        +
      </button>
      <PointType pointType={p.pointType} />
      <RouteData
        carNum={route.garbageCarNumber}
        calcTime={pointInRoute.calculatedArrivalTime}
        pointStatus={p.pointStatus}
      />
      <p className="route-panel__route">Маршрут музоровоза</p>
      <ul className="route-panel__route-list">
        {routePoints.map((point, i) => (
          <PointListItem
            key={i}
            carPlace={isCarHere2(i)}
            isClickedPoint={i === idxInRoute}
            address={point.pointAddress}
            isLast={i === maxIdx}
          />
        ))}
      </ul>
    </div>
  );
};
